import React, { useReducer } from "react";
import Store from "./StoreContext";
import Reducer from "./reducer";
import intialState from "./intialState.js"
import StateFunction from "./StateFunction";
function State(props) {
  const [state, dispatch] = useReducer(Reducer, intialState);
  return (
    <Store.Provider
      value={{
       state :  state ,
       dispatch : dispatch,
       StateFunction : StateFunction 
      }}
    >
      {props.children}
    </Store.Provider>
  );
}

export default State;